import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["linkComponent"];
import React from 'react';
export var Link = function Link(_ref) {
  var linkComponent = _ref.linkComponent,
    props = _objectWithoutProperties(_ref, _excluded);
  // Hack?
  var Component = linkComponent || 'a';
  return /*#__PURE__*/React.createElement(Component, props);
};